import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const RTIPage = () => {
  useEffect(() => {
    document.title = 'Right To Information | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/website-info">
          <div id="stick_right"></div>
        </Link>

        {/* RTI Content */}
        <h3 className="heading_cet">Right to Information</h3>
        <div className="container" style={{marginTop: '50px'}}>
          <div className="row">
            <div className="col-lg-4 col-lg-offset-2">
              <div className="panel panel-default">
                <div className="panel-body">
                  <center>
                    <img className="img-thumbnail" src="Krishnamurthy.jpg" alt="M N Krishnamurthy" />
                    <label className="red">Appellate Authority</label><br />
                    <label className="big">Mr. M N Krishnamurthy</label>
                  </center>
                </div>
                <div className="panel-footer">
                  <center>
                    <label className="deplbl">ADDRESS :</label>
                    <label className="big">#3c -910 HRBR,layout Kalyan Nagar Ist block. BANGALURU 560043</label>
                  </center>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="panel panel-default">
                <div className="panel-body">
                  <center>
                    <img className="img-thumbnail" src="Harish Kumar1.jpg" alt="Harish Kumar" />
                    <label className="red">Public Information Officer</label><br />
                    <label className="big">Mr. Harish Kumar</label>
                  </center>
                </div>
                <div className="panel-footer">
                  <center>
                    <label className="deplbl">ADDRESS :</label><br />
                    <label className="big">B4/317B, Keshav Puram, Delhi - 110035</label>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default RTIPage;